import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";
import dayjs from "dayjs";
import "../IncidentSidebar/IncidentSidebar.scss";

const JiraIncidentDetails = ({ incidentData, diff }) => {
  if (!incidentData) return null;

  return (
    <TableContainer>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell className="inc-tbl-cell" component="th" scope="row">
              Incident ID
            </TableCell>
            <TableCell className="inc-tbl-cell">
              {incidentData.incidentId || "-"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="inc-tbl-cell" component="th" scope="row">
              Ticket ID
            </TableCell>
            <TableCell className="inc-tbl-cell">
              {incidentData.ticketId
                ? incidentData.ticketId.replace(/^[A-Za-z]+-/, "")
                : "-"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="inc-tbl-cell" component="th" scope="row">
              Creation Time
            </TableCell>
            <TableCell className="inc-tbl-cell">
              {incidentData.createdDate
                ? dayjs(incidentData.createdDate)
                    .add(diff, "minute")
                    .format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="inc-tbl-cell" component="th" scope="row">
              Updated Time
            </TableCell>
            <TableCell className="inc-tbl-cell">
              {incidentData.incidentUpdatedDate
                ? dayjs(incidentData.incidentUpdatedDate)
                    .add(diff, "minute")
                    .format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="inc-tbl-cell" component="th" scope="row">
              Priority
            </TableCell>
            <TableCell className="inc-tbl-cell">
              <span
                className={
                  incidentData.incidentPriority &&
                  `mdrIncidentTableSeverityColumn ${incidentData.incidentPriority.toLowerCase()}`
                }
              >
                {incidentData.incidentPriority || "-"}
              </span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="inc-tbl-cell" component="th" scope="row">
              Status
            </TableCell>
            <TableCell className="inc-tbl-cell">
              {incidentData.incidentStatus || "-"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="inc-tbl-cell" component="th" scope="row">
              Category
            </TableCell>
            <TableCell className="inc-tbl-cell">
              {incidentData.incidentCategory || "-"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="inc-tbl-cell" component="th" scope="row">
              Type
            </TableCell>
            <TableCell className="inc-tbl-cell">
              {incidentData.incidentType || "-"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="inc-tbl-cell" component="th" scope="row">
              Assignee
            </TableCell>
            <TableCell className="inc-tbl-cell">
              {incidentData.assignee || "-"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="inc-tbl-cell" component="th" scope="row">
              Description
            </TableCell>
            <TableCell className="inc-tbl-cell">
              {incidentData.description || "-"}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default JiraIncidentDetails;
